// extracted by mini-css-extract-plugin
export default {"ellipsis":"_5Y82pL60JYwf2H4Zo-GXT"};